// redux/store.js
import { configureStore } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import plaidReducer from "./slices/plaidSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer, // Note: Changed from 'login' to 'auth' to match new slice
    plaid: plaidReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ["persist/PERSIST", "persist/REHYDRATE"],
      },
    }),
});

export default store;
